import * as paymentConstants from "../constants/paymentConstants";

export const paymentReducers = (state = {}, action) => {
  switch (action.type) {
    case paymentConstants.PAYMENT_INITIATE_REQUEST:
      return { loading: true };
    case paymentConstants.PAYMENT_INITIATE_SUCCESS:
      return { loading: false, paymentData: action.payload };
    case paymentConstants.PAYMENT_INITIATE_FAIL:
      return { loading: false, error: action.payload };
    case paymentConstants.PAYMENT_VERIFY_REQUEST:
      return { loading: true };
    case paymentConstants.PAYMENT_VERIFY_SUCCESS:
      return { loading: false };
    case paymentConstants.PAYMENT_VERIFY_FAIL:
      return { loading: false, error: action.payload };
    case paymentConstants.SUBSCRIPTION_CANCEL_REQUEST:
      return { loading: true };
    case paymentConstants.SUBSCRIPTION_CANCEL_SUCCESS:
      return { loading: false, paymentData: action.payload };
    case paymentConstants.SUBSCRIPTION_CANCEL_FAIL:
      return { loading: false, error: action.payload };
    case paymentConstants.SUBSCRIPTION_PAUSE_REQUEST:
      return { loading: true };
    case paymentConstants.SUBSCRIPTION_PAUSE_SUCCESS:
      return { loading: false, paymentData: action.payload };
    case paymentConstants.SUBSCRIPTION_PAUSE_FAIL:
      return { loading: false, error: action.payload };
    case paymentConstants.SUBSCRIPTION_RESUME_REQUEST:
      return { loading: true };
    case paymentConstants.SUBSCRIPTION_RESUME_SUCCESS:
      return { loading: false, paymentData: action.payload };
    case paymentConstants.SUBSCRIPTION_RESUME_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
